import { motion } from "framer-motion";

type TimeFilterGroupProps = {
  filters: string[];
  activeFilter: number;
  onChange: (filter: number) => void;
};

const TimeFilterGroup = ({
  filters,
  activeFilter,
  onChange,
}: TimeFilterGroupProps) => {
  return (
    <div className="flex gap-3 flex-wrap">
      {filters.map((filter, index) => {
        const isActive = index === activeFilter;

        return (
          <motion.button
            key={filter}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + index * 0.1 }}
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onChange(index)}
            className={`relative px-5 py-2.5 rounded-xl text-shopify-btn overflow-hidden ${
              isActive
                ? "text-white shadow-lg"
                : "bg-slate-100/80 text-brand-text hover:bg-slate-200/80"
            }`}
          >
            {isActive && (
              <motion.div
                layoutId="activeFilter"
                className="absolute inset-0 bg-brand-sidebar"
                transition={{ type: "spring", duration: 0.6 }}
              />
            )}
            <span className="relative z-10">{filter}</span>
          </motion.button>
        );
      })}
    </div>
  );
};
export default TimeFilterGroup;
